import {
  Component,
  HostListener,
  Input,
  OnInit,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  ComponentFactoryResolver,
  ChangeDetectionStrategy,
  Output,
  OnChanges,
  EventEmitter,
} from "@angular/core";
//import { PopupItem } from './popup-item';
import { ModalDirective } from "../directives/modal.directive";
import { ModalService } from "../services/modal.service";
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from "@angular/animations";
import { Router, NavigationStart, NavigationEnd } from "@angular/router";
import { Modal } from "../modal.item";
import { modalComponentsListDataModel } from "../modal.components.list";

export enum KEY_CODE {
  ESCAPE = 27,
}

import { TestComponent } from "../../../test/test.component";
import { filter } from "rxjs/operators";

@Component({
  // changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-modal",
  // template: '<div><div modal-host></div></div>',
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.scss"],
  animations: [
    trigger("popup-dialog", [
      transition("void => *", [
        style({ transform: "scale3d(.3, .3, .3)" }),
        animate(100),
      ]),
      transition("* => void", [
        animate(100, style({ transform: "scale3d(.0, .0, .0)" })),
      ]),
    ]),
  ],
})
export class ModalComponent implements OnInit, AfterViewInit, OnDestroy {
  //@ViewChild('modalContainer') input;

  @HostListener("window:keyup", ["$event"])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode === KEY_CODE.ESCAPE) {
      this.modalService.closePopup();
    }
  }
  /**
   *
   */
  @ViewChild(ModalDirective) modalDirective: ModalDirective;

  /**
   *
   */
  @Input() componentList: any;

  /**
   *
   */
  private currentComponent: string = null;

  /**
   *
   */
  private currentComponentData: object = {};

  // to save unload components
  private saveComponent: Array<any> = [];

  /**
   *
   */
  private currentComponentClassName: string = null;
  get getcurrentComponentClassName() {
    return this.currentComponentClassName;
  }
  /**
   *
   */
  private showPopup: boolean = false;
  get getshowPopup() {
    return this.showPopup;
  }

  // save previous url
  private previousUrl;

  private modalCustomClass;

  private currentComponentName;
  get isProfileComponent() {
    return this.currentComponentName === "ProfileNavbarComponent";
  }

  private scrollPostion: number;
  /**
   *
   */
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private modalService: ModalService,
    private Router: Router,
  ) {
    //
  }

  ngOnInit() {
    this.componentList = modalComponentsListDataModel.getList();
  }
  /**
   *
   */
  ngAfterViewInit(): void {
    this.modalService.componentChangeEvent.subscribe(
      (componentData: object) => {
        this.currentComponentData = componentData;
        this.loadComponent(componentData["name"]);
        // this.setComponentCssClassName(componentName)
      },
    );

    this.modalService.onCloseEvent().subscribe(() => {
      this.close();
    });

    this.Router.events.subscribe((value) => {
      if (
        value instanceof NavigationEnd &&
        this.currentComponentData["close"]
      ) {
        this.close();
      }
      if (value instanceof NavigationEnd && !value.url.includes("profile")) {
        this.previousUrl = value.url;
      }
    });
  }

  loadComponent(name: string): void {
    this.currentComponentName = name;
    /**
     * if there is even one component loaded, clear it
     */
    // if (this.modalDirective.viewContainerRef.length) {
    //     this.unloadComponent();
    // }

    // //Save opening component name

    //this.currentComponent = name;
    // saving component in array
    this.saveComponent.push(this.modalDirective.viewContainerRef);

    // add hide body
    // document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
    this.scrollPostion = window.pageYOffset;
    document.getElementsByTagName("body")[0].style.bottom =
      `${this.scrollPostion}px`;
    document
      .getElementsByTagName("body")[0]
      .classList.add("show-disabled-scroll");

    // modal is hidden, so need this class
    this.modalCustomClass = document.getElementsByClassName(
      "custom-modal-component",
    )[0];
    this.modalCustomClass.classList.add("d-flex");

    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(
        this.componentList[name],
      );
    const component =
      this.saveComponent[this.saveComponent.length - 1].createComponent(
        componentFactory,
      );

    componentFactory.inputs.map((input) => {
      const { propName = null, templateName = null } = input || {};
      if (this.currentComponentData[propName]) {
        component.instance[propName] = this.currentComponentData[propName];
      }
    });

    // if there are multiple modals, hides previous ones
    if (
      document.getElementsByClassName("modal-classes")[0].children[
        this.saveComponent.length
      ]
    ) {
      document
        .getElementsByClassName("modal-classes")[0]
        .children[
          this.saveComponent.length
        ].classList.add("position-absolute", "bg-white", this.isProfileComponent ? "p-3" : "p-0");
      document
        .getElementsByClassName("modal-classes")[0]
        .children[this.saveComponent.length - 1].classList.add("d-none");
    }

    // this.modalDirective.viewContainerRef.createComponent(componentFactory);
    // this.showPopup = true;
  }

  setComponentCssClassName(compoentName: string): void {}

  close() {
    // this.showPopup = false;
    this.unloadComponent();
  }

  closeModal() {
    // jerjerobt ase iyos, da current elementze clickit gamortva rom gaswordeba, mere gadaketdeba esec msgavsi logikit
    // if (this.Router.url === this.previousUrl) {
    this.close();
    // }

    this.Router.navigate([this.previousUrl ? this.previousUrl : "/"]);
  }

  private unloadComponent() {
    if (this.saveComponent.length) {
      document
        .getElementsByClassName("modal-classes")[0]
        .children[this.saveComponent.length - 1].classList.remove("d-none");
      this.saveComponent[this.saveComponent.length - 1].remove();
      this.saveComponent.pop();
    }

    if (this.modalCustomClass) {
      this.modalCustomClass.classList.remove("d-flex");
      // document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
      document
        .getElementsByTagName("body")[0]
        .classList.remove("show-disabled-scroll");
      window.scrollTo({
        top: this.scrollPostion,
        left: 0,
      });
      document.getElementsByTagName("body")[0].style.removeProperty("bottom");
    }
    // this.modalDirective.viewContainerRef.remove();
  }

  ngOnDestroy() {}
}
